/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("MistralProvider", ["AIProviderBase"], function (context, cls) {
  /**
   * Mistral AI provider
   * @class MistralProvider
   * @memberOf classes
   */
  class MistralProvider extends cls.AIProviderBase /** @lends classes.MistralProvider.prototype */ {
    constructor() {
      super("mistral", "Mistral", "remote", { rewrite: true });
    }

    /**
     * @inheritdoc
     */
    _getDirectApiHost() {
      return "https://api.mistral.ai";
    }

    /**
     * Base URL for Mistral Chat Completion API
     * @returns {string}
     * @private
     */
    _getBaseUrl() {
      return this._buildApiUrl("v1/chat/completions");
    }

    /**
     * Rewrite text using OpenAI Responses API
     * @inheritDoc
     */
    async rewrite(text, options = {}) {
      const preparedText = this._prepareRewriteInput(text);
      if (preparedText === null) {
        return null;
      }

      const instructions = this._buildRewritePrompt();
      const input = this._buildRewriteInput(preparedText, options);

      const data = await this._request(this._getBaseUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this._resolveApiKey(options.apiKey)}`
        },
        body: {
          model: this._getModel("rewrite"),
          messages: [
            { role: "system", content: instructions },
            { role: "user", content: input }
          ]
        }
      });

      return this._extractOutputText(data);
    }

    /**
     * Extract output text from Mistral Chat Completions payload
     * @param {Object} response
     * @returns {string|null}
     * @private
     */
    _extractOutputText(response) {
      const content = response?.choices?.[0]?.message?.content;
      if (typeof content !== "string") {
        return null;
      }
      return content.trim();
    }
  }

  cls.AIProviderBase.registerProvider(MistralProvider);
  cls.MistralProvider = MistralProvider;
});
